export default "__VITE_ASSET__C0zHxI_b__"